import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheMap } from '@shared/caching/cache-map';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

const MAX_HTTP_CACHE_AGE = 10000; // in milliseconds

const CACHE_URLS = [
    // '/api/services/app/Shipment/GetTrackingNumbers',
    // '/api/services/app/Shipment/GetOutboundShipmentAvailableItems',
] as const;

@Injectable({ providedIn: 'root' })
export class CachingInterceptor implements HttpInterceptor {
    private readonly cacheMap = new CacheMap<string, HttpResponse<any>>(MAX_HTTP_CACHE_AGE);

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (!this.shouldCacheRequest(req)) {
            return next.handle(req);
        }

        const cachedResponse = this.cacheMap.get(req.urlWithParams);

        if (cachedResponse !== undefined) {
            return of(cachedResponse);
        }

        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    this.cacheMap.put(req.urlWithParams, event);
                }
            })
        );
    }

    private shouldCacheRequest(req: HttpRequest<any>) {
        return (req.method === 'GET') && (CACHE_URLS.some(url => req.url.indexOf(url) > -1));
    }
}
